import React, { useState, useEffect } from "react";
import { qs } from "url-parse";
import { withRouter } from "react-router-dom";
import getDisplayName from "./getDisplayName";

function getSearch(search, prefix) {
  const data = qs.parse(search);
  const newData = {};

  Object.keys(data).forEach(key => {
    if (key.startsWith(prefix)) {
      newData[key] = data[key];
    }
  });

  return newData;
}

function isEqual(data1, data2) {
  if (Object.keys(data1).length != Object.keys(data2).length) {
    return false;
  }

  const keys = Object.keys(data1);

  for (let i = 0; i < keys.length; i++) {
    if (data1[keys[i]] != data2[keys[i]]) {
      return false;
    }
  }

  return true;
}

function stripPrefix(data, prefix) {
  const newData = {};

  Object.keys(data).forEach(key => {
    const r = new RegExp(`^${prefix}`);
    const newKey = key.replace(r, "");
    newData[newKey] = data[key];
  });

  return newData;
}

export function addPrefix(data, prefix) {
  const newData = {};

  Object.keys(data).forEach(key => {
    newData[`${prefix}${key}`] = data[key];
  });

  return newData;
}

const withSearch = (WrappedComponent, prefix = "") => {
  const WithSearch = props => {
    const [search, setSearchState] = useState(
      stripPrefix(getSearch(props.location.search, prefix), prefix)
    );

    const _getSearch = params => {
      const fullSearchData = qs.parse(props.location.search);
      const prefixParams = addPrefix(params, prefix);
      const newSearch = Object.assign({}, fullSearchData, prefixParams);
      const s = qs.stringify(newSearch);
      return s;
    };

    const setSearch = (params, state) => {
      const s = _getSearch(params);
      props.history.push({ search: "?" + s, state });
    };

    const replaceSearch = (params, state) => {
      const s = _getSearch(params);
      props.history.replace({ search: "?" + s, state });
    };

    useEffect(() => {
      const newSearch = stripPrefix(
        getSearch(props.location.search, prefix),
        prefix
      );
      if (!isEqual(search, newSearch)) {
        setSearchState(newSearch);
      }
    }, [props.location.search]);

    return (
      <WrappedComponent
        {...props}
        setSearch={setSearch}
        replaceSearch={replaceSearch}
        search={search}
      />
    );
  };

  WithSearch.displayName = `withSearch(${getDisplayName(WrappedComponent)})`;

  return withRouter(WithSearch);
};

export function getStripSearch(search, prefix) {
  const data = getSearch(search, prefix);
  return stripPrefix(data, prefix);
}

export default withSearch;
